import script from "./drawlayoutComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./drawlayoutComponent.vue?vue&type=script&setup=true&lang=js"

import "./drawlayoutComponent.vue?vue&type=style&index=0&id=1472a044&lang=scss&scoped=true"

import exportComponent from "D:\\liu\\jmzc\\jimuERPVUE\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1472a044"]])

export default __exports__